import * as React from 'react';
import MaterialUITextField, { OutlinedTextFieldProps, StandardTextFieldProps } from '@material-ui/core/TextField';
import { FormControlProps } from '@material-ui/core/FormControl';
import { WrappedFieldProps } from 'redux-form';

export type Props = FormControlProps & StandardTextFieldProps & OutlinedTextFieldProps & WrappedFieldProps;

export const TextField: React.FC<Props> = ({ meta, helperText, input, ...props }) => (
  <MaterialUITextField
    error={!!((meta.touched || meta.submitFailed) && meta.error)}
    helperText={(meta.touched && meta.error) || helperText}
    variant={props.multiline ? 'outlined' : undefined}
    {...input}
    {...props}
  />
);
